import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";


type Props = {
    onActionDelete: (idPgto: number | null, openState: boolean) => void,
    onActionEdit: (idPgto: number | null, openState: boolean) => void,

}

export const GeneratePgtoContratosColumns = ({
    onActionDelete,
    onActionEdit,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Parcela";
            case 1:
                return "Entrada";
            case 2:
                return "Cancelada";
            case 3:
                return "Parcela secundária";
            default:
                return "Nda";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "gray";
            case 1:
                return "green";
            case 2:
                return "red";
            case 3:
                return "blue";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0:
                return "Parcela";
            case 1:
                return "Entrada";
            case 2:
                return "Cancelada";
            case 3:
                return "Parcela\nsecundária";
            default:
                return "?";
        }
    };


    const columns: GridColDef[] = [
        {
            field: "tipo",
            filterable: false,
            headerName: "Tipo",
            minWidth: 70,
            width: 70,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "numeroParcela",
            filterable: false,
            headerName: "Número da Parcela",
            minWidth: 70,
            width: 70,
            align: "center",
            sortable: false,
        },
        {
            field: "observacao",
            filterable: false,
            headerName: "Descrição Pagamento",
            flex: 1,
            minWidth: 120,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-start items-start break-normal">
                    {params.value}
                </div>
            )
        },
        {
            field: "percentualReajuste",
            filterable: false,
            headerName: "Percentual Reajuste",
            minWidth: 75,
            width: 75,
            align: 'center',
            sortable: false,
            renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
        },
        {
            field: "valorSemReajuste",
            filterable: false,
            headerName: "Valor a Receber Sem Reajuste",
            minWidth: 110,
            width: 110,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorInicial",
            filterable: false,
            headerName: "Valor Parcela Nominal",
            minWidth: 110,
            width: 110,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorReceber",
            filterable: false,
            headerName: "Valor a Receber com Reajuste",
            minWidth: 110,
            width: 110,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorJuros",
            filterable: false,
            headerName: "Valor Juros",
            minWidth: 90,
            width: 90,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorFinal",
            filterable: false,
            headerName: "Valor Receber com Reajuste + Juros",
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataReceber",
            filterable: false,
            headerName: "Data a Receber",
            minWidth: 90,
            width: 90,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorRecebido",
            filterable: false,
            headerName: "Valor Recebido",
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataRecebido",
            filterable: false,
            headerName: "Data Recebido",
            minWidth: 90,
            width: 90,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorSaldoDevedor",
            filterable: false,
            headerName: "Valor do saldo devedor",
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: 'idPgtoContratoFinanceiro',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }
    ];

    return columns

}